export const BELT_COLORS = {
  branca: "#E5E5E0", cinza: "#9CA3AF", amarela: "#FACC15", laranja: "#F97316",
  verde: "#16A34A", azul: "#2563EB", roxa: "#7C3AED", marrom: "#78350F", preta: "#141414",
};

export const BELTS = Object.keys(BELT_COLORS);

export const BELT_LABELS = Object.fromEntries(BELTS.map((b) => [b, b[0].toUpperCase() + b.slice(1)]));

export const maxDegree = (belt) => (belt === "preta" ? 10 : 4);

export const degreeLabel = (degree) => `${degree} ${degree === 1 ? "grau" : "graus"}`;

export default function BeltBar({ belt = "branca", degree = 0, size = "md", testid }) {
  const color = BELT_COLORS[belt] || BELT_COLORS.branca;
  const tipColor = belt === "preta" ? "#B91C1C" : "#0A0A0B";
  const dims = size === "sm" ? "h-5 w-36" : "h-9 w-full max-w-sm";
  const max = maxDegree(belt);
  const stripe = belt === "preta" ? (size === "sm" ? "w-[2px]" : "w-1") : size === "sm" ? "w-1.5" : "w-2.5";
  const count = Math.max(0, Math.min(degree, max));
  return (
    <div
      className={`relative ${dims} overflow-hidden shrink-0 border border-white/25`}
      style={{ background: color }}
      data-testid={testid}
      title={`Faixa ${BELT_LABELS[belt]} · ${degreeLabel(count)}`}
    >
      <div
        className="absolute right-[12.5%] top-0 bottom-0 w-1/4 flex items-stretch justify-evenly"
        style={{ background: tipColor }}
        aria-hidden="true"
      >
        {Array.from({ length: max }).map((_, i) => (
          <span
            key={i}
            className={`${stripe} h-full shrink-0 ${i >= max - count ? "bg-white" : "bg-transparent"}`}
          />
        ))}
      </div>
    </div>
  );
}
